import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/store.js'
import BootstrapVue from 'bootstrap-vue'
import cookieconsent from 'vue-cookieconsent-component'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/app.scss'
import 'vue-swatches/dist/vue-swatches.css'
import 'vue-slider-component/theme/antd.css'
import './registerServiceWorker'
import VueGtag from 'vue-gtag'

const fb = require('./firebaseConfig.js')

Vue.use(BootstrapVue)
Vue.use(VueGtag, {
  config: { id: 'G-XB39GP4XSW' }
}, router)

Vue.component('cookie-consent', cookieconsent)

Vue.config.productionTip = false

// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  }
})
